import api from './api';
import { TeacherProfile } from '../types/models';

export async function getTeacherProfile(username: string): Promise<TeacherProfile> {
  const res = await api.get(`/teachers/${username}`);
  return res.data;
}

export async function updateTeacherProfile(userId: string, updates: {
  bio?: string;
  yearsExperience?: number;
  specialties?: string[];
  certifications?: string[];
  yogaAllianceUrl?: string | null;
}): Promise<void> {
  await api.put(`/teachers/${userId}`, updates);
}
